import { Divider, Link, Stack, Typography } from '@mui/material';
import {
  courseTypesLabels,
  modalityTypesLabels,
} from '@/constants/catalog/course';
import { periodTypesLabels } from '@/constants/catalog/offer';
import { EligibleResourceType } from '@/data/subsidy/policies/interfaces';
import { PriceTypes } from '@/models/catalog/course';
import { KeyValue } from '@/packages/subsidy/pages/refund-request/components/key-value';
import { useRefundRequest } from '@/packages/subsidy/pages/refund-request/context';
import { formatMoney } from '@/utils/format-money';
import { formatDuration } from '@/utils/masks/time';
import { refundValueDetail } from '@/utils/refund-value-detail';

export const Details = () => {
  const { resourceApproval } = useRefundRequest();

  const policy = resourceApproval?.policies[0];
  const course = resourceApproval?.resource.course;
  const { policyText } = refundValueDetail(policy?.limits);

  return (
    <Stack gap={2}>
      <KeyValue label="Política" value={policy?.name || ''} />
      <KeyValue
        label="Catálogo"
        value={
          course?.source === EligibleResourceType.Catalog
            ? 'Plataforma Galena'
            : 'Fora da Galena'
        }
      />
      <KeyValue label="Tipo de item" value={resourceApproval?.category || ''} />
      {course?.institution_name && (
        <KeyValue label="Instituição" value={course?.institution_name || ''} />
      )}
      <KeyValue label="Nome do item" value={resourceApproval?.name || ''} />
      {course?.course_type && (
        <KeyValue
          label="Categoria"
          value={courseTypesLabels[course?.course_type] || ''}
        />
      )}
      {course?.modality && (
        <KeyValue
          label="Modalidade"
          value={modalityTypesLabels[course?.modality]}
        />
      )}
      {course?.address?.state && (
        <KeyValue label="Estado" value={course?.address?.state} />
      )}
      {course?.address?.city && (
        <KeyValue label="Cidade" value={course?.address?.city} />
      )}
      {course?.address?.campus && (
        <KeyValue label="Polo" value={course?.address?.campus} />
      )}
      {course?.period && (
        <KeyValue label="Turno" value={periodTypesLabels[course?.period]} />
      )}
      {course?.workload && (
        <KeyValue label="Carga horária" value={course?.workload} />
      )}
      {course?.duration_type && (
        <KeyValue
          label="Duração"
          value={formatDuration(course?.duration_type, course?.duration)}
        />
      )}
      <KeyValue
        label="Tipo de pagamento"
        value={
          resourceApproval?.sale_type === PriceTypes.OneOff ? 'Único' : 'Mensal'
        }
      />
      <KeyValue
        label="Valor"
        value={formatMoney(resourceApproval?.sale_price || '')}
      />
      {course?.link && <KeyValue label="Link" value={course?.link} />}
      {resourceApproval?.request_reason && (
        <KeyValue
          label="Motivo do pedido"
          value={resourceApproval?.request_reason}
        />
      )}
      <Divider sx={{ my: 2 }} />
      <KeyValue
        label="Limite de reembolso"
        value={formatMoney(resourceApproval?.policy_refund_limit || '')}
      />
      <Typography variant="body2">
        {policyText}{' '}
        <Link
          href="/meus-reembolsos/minhas-politicas"
          target="_blank"
          color="info.main"
        >
          Ver regras
        </Link>
        .
      </Typography>
      <Typography variant="body2">
        O reembolso final depende também do seu saldo disponível.
      </Typography>
    </Stack>
  );
};
